/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Admin } from '../models/Admin';
import type { Adviser } from '../models/Adviser';
import type { Company } from '../models/Company';
import type { Member } from '../models/Member';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProfileService {

    /**
     * Create Member API Endpoint
     * Create Member
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static createMember(
requestBody: {
userId: string;
email: string;
firstName: string;
lastName: string;
firstNameKana: string;
lastNameKana: string;
gender: string;
birthday: string;
country: string;
areaId: number;
phoneNumber: string;
zipCode: string;
province: string;
city: string;
streetNo?: string;
building?: string;
isMagazinRegister?: boolean;
startupStageId: number;
startupPlanId: number;
startupName?: string;
startupKanaName?: string;
startupOpenDate?: string;
startupUrl?: string;
routeToKnowId: number;
routeComment?: string;
startupBusinessTypeId: number;
isLoungeMember?: boolean;
comment?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Member;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/member',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * List Member API Endpoint
     * List Member
     * @param xAccessToken 
     * @param offset 
     * @param limit 
     * @param area 
     * @param keyword 
     * @param orderBy 
     * @param sortOrder 
     * @returns any successful operation
     * @throws ApiError
     */
    public static listMember(
xAccessToken: string,
offset?: number,
limit?: number,
area?: string,
keyword?: string,
orderBy?: string,
sortOrder?: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
members?: Array<Member>;
count?: number;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/member',
            headers: {
                'x-access-token': xAccessToken,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'area': area,
                'keyword': keyword,
                'orderBy': orderBy,
                'sortOrder': sortOrder,
            },
            errors: {
                400: `Invalid Parameters supplied`,
                401: `Not Authorized`,
                403: `Forbidden`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Get Member API Endpoint
     * Get Member Detail
     * @param xAccessToken 
     * @param userId 
     * @returns any successful operation
     * @throws ApiError
     */
    public static memberDetail(
xAccessToken: string,
userId: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: Member;
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/member/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Invalid ID supplied`,
                401: `Not Authorized`,
                404: `Record Not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Update Member API Endpoint
     * Update Member
     * @param xAccessToken 
     * @param userId UserID of member to return
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateMember(
xAccessToken: string,
userId: string,
requestBody: {
firstName?: string;
lastName?: string;
firstNameKana?: string;
lastNameKana?: string;
gender?: string;
birthday?: string;
country?: string;
areaId?: number;
phoneNumber?: string;
zipCode?: string;
province?: string;
city?: string;
streetNo?: string;
building?: string;
isMagazinRegister?: boolean;
startupStageId?: number;
startupPlanId?: number;
startupName?: string;
startupKanaName?: string;
startupOpenDate?: string;
startupUrl?: string;
routeToKnowId?: number;
routeComment?: string;
startupBusinessTypeId?: number;
isLoungeMember?: boolean;
comment?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Member;
}> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/profile/member/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Delete Member API Endpoint
     * Delete Member
     * @param xAccessToken 
     * @param userId UserID of member to delete
     * @returns any successful operation
     * @throws ApiError
     */
    public static deleteMember(
xAccessToken: string,
userId: string,
): CancelablePromise<{
status?: number;
message?: string;
}> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/profile/member/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Invalid ID supplied`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Upload File API Endpoint
     * Upload File
     * @param formData 
     * @returns any successful operation
     * @throws ApiError
     */
    public static uploadFile(
formData: {
file?: Blob;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: any;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Create Adviser API Endpoint
     * Create Adviser
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static createAdviser(
requestBody: {
userId: string;
email: string;
photoUrl: string;
firstName: string;
lastName: string;
firstNameKana: string;
lastNameKana: string;
jobTitleId: string;
otherJobTitle?: string;
gender: string;
birthday: string;
country: string;
areaId: number;
phoneNumber: string;
zipCode: string;
province: string;
city: string;
streetNo?: string;
building?: string;
pr: string;
message: string;
isLoungeMember?: boolean;
isResident?: boolean;
comment?: string;
career: Array<any>;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Adviser;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/adviser',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * List Adviser API Endpoint
     * List Adviser
     * @param xAccessToken 
     * @param offset 
     * @param limit 
     * @param area 
     * @param job 
     * @param isResident 
     * @param orderBy 
     * @param sortOrder 
     * @returns any successful operation
     * @throws ApiError
     */
    public static listAdviser(
xAccessToken?: string,
offset?: number,
limit?: number,
area?: string,
job?: string,
isResident?: boolean,
orderBy?: string,
sortOrder?: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
advisers?: Array<Adviser>;
count?: number;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/adviser',
            headers: {
                'x-access-token': xAccessToken,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'area': area,
                'job': job,
                'isResident': isResident,
                'orderBy': orderBy,
                'sortOrder': sortOrder,
            },
            errors: {
                400: `Invalid Parameters supplied`,
                401: `Not Authorized`,
                403: `Forbidden`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Get Adviser API Endpoint
     * Get Adviser Detail
     * @param userId 
     * @returns any successful operation
     * @throws ApiError
     */
    public static adviserDetail(
userId: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: Adviser;
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/adviser/{userID}',
            path: {
                'userID': userId,
            },
            errors: {
                400: `Invalid ID supplied`,
                401: `Not Authorized`,
                404: `Not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Update Adviser API Endpoint
     * Update Adviser
     * @param xAccessToken 
     * @param userId UserID of adviser to return
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateAdviser(
xAccessToken: string,
userId: string,
requestBody: {
photoUrl?: string;
firstName?: string;
lastName?: string;
firstNameKana?: string;
lastNameKana?: string;
jobTitleId?: string;
otherJobTitle?: string;
gender?: string;
birthday?: string;
country?: string;
areaId?: number;
phoneNumber?: string;
zipCode?: string;
province?: string;
city?: string;
streetNo?: string;
building?: string;
pr?: string;
message?: string;
isLoungeMember?: boolean;
isResident?: boolean;
comment?: string;
status?: string;
career?: Array<any>;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Adviser;
}> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/profile/adviser/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Delete Adviser API Endpoint
     * Delete Adviser
     * @param xAccessToken 
     * @param userId UserID of adviser to delete
     * @returns any successful operation
     * @throws ApiError
     */
    public static deleteAdviser(
xAccessToken: string,
userId: string,
): CancelablePromise<{
status?: number;
message?: string;
}> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/profile/adviser/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Invalid ID supplied`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Create Company API Endpoint
     * Create Company
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static createCompany(
requestBody: {
userID?: string;
email: string;
companyName: string;
companyNameKana: string;
managerFirstName: string;
managerLastName: string;
managerFirstNameKana: string;
managerLastNameKana: string;
phoneNumber: string;
areaId: number;
headOfficeZipCode: string;
headOfficeProvince: string;
headOfficeCity: string;
headOfficeStreetNo?: string;
headOfficeBuilding?: string;
headOfficePhoneNumber: string;
headOfficeUrl?: string;
officeZipCode?: string;
officeProvince?: string;
officeCity?: string;
officeStreetNo?: string;
officeBuilding?: string;
officePhoneNumber?: string;
officeUrl?: string;
startupDate?: string;
capitalFund?: number;
annualSales?: number;
employeeCount?: number;
businessContent?: string;
businessTypeId: number;
isLoungeMember?: boolean;
comment?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Company;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/company',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * List Company API Endpoint
     * List Company
     * @param xAccessToken 
     * @param offset 
     * @param limit 
     * @param area 
     * @param orderBy 
     * @param sortOrder 
     * @returns any successful operation
     * @throws ApiError
     */
    public static listCompany(
xAccessToken: string,
offset?: number,
limit?: number,
area?: string,
orderBy?: string,
sortOrder?: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
companies?: Array<Company>;
count?: number;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/company',
            headers: {
                'x-access-token': xAccessToken,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'area': area,
                'orderBy': orderBy,
                'sortOrder': sortOrder,
            },
            errors: {
                400: `Invalid Parameters supplied`,
                401: `Not Authorized`,
                403: `Forbidden`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Get Company API Endpoint
     * Get Company Detail
     * @param xAccessToken 
     * @param userId 
     * @returns any successful operation
     * @throws ApiError
     */
    public static companyDetail(
xAccessToken: string,
userId: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: Company;
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/company/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Invalid ID supplied`,
                401: `Not Authorized`,
                404: `Not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Update Company API Endpoint
     * Update Company
     * @param xAccessToken 
     * @param userId UserID of company to return
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateCompany(
xAccessToken: string,
userId: string,
requestBody: {
companyName?: string;
companyNameKana?: string;
managerFirstName?: string;
managerLastName?: string;
managerFirstNameKana?: string;
managerLastNameKana?: string;
phoneNumber?: string;
areaId?: number;
headOfficeZipCode?: string;
headOfficeProvince?: string;
headOfficeCity?: string;
headOfficeStreetNo?: string;
headOfficeBuilding?: string;
headOfficePhoneNumber?: string;
headOfficeUrl?: string;
officeZipCode?: string;
officeProvince?: string;
officeCity?: string;
officeStreetNo?: string;
officeBuilding?: string;
officePhoneNumber?: string;
officeUrl?: string;
startupDate?: string;
capitalFund?: number;
annualSales?: number;
employeeCount?: number;
businessContent?: string;
businessTypeId?: number;
isLoungeMember?: boolean;
comment?: string;
status?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Company;
}> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/profile/company/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Delete Company API Endpoint
     * Delete Company
     * @param xAccessToken 
     * @param userId UserID of company to delete
     * @returns any successful operation
     * @throws ApiError
     */
    public static deleteCompany(
xAccessToken: string,
userId: string,
): CancelablePromise<{
status?: number;
message?: string;
}> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/profile/company/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Invalid ID supplied`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Create Admin API Endpoint
     * Create Admin
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static createAdmin(
requestBody: {
userId: string;
email: string;
firstName: string;
lastName: string;
firstNameKana: string;
lastNameKana: string;
areaId: number;
comment?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Admin;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/profile/admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * List Admin API Endpoint
     * List Admin
     * @param xAccessToken 
     * @param offset 
     * @param limit 
     * @param area 
     * @param orderBy 
     * @param sortOrder 
     * @returns any successful operation
     * @throws ApiError
     */
    public static listAdmin(
xAccessToken: string,
offset?: number,
limit?: number,
area?: string,
orderBy?: string,
sortOrder?: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
admins?: Array<Admin>;
count?: number;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/admin',
            headers: {
                'x-access-token': xAccessToken,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'area': area,
                'orderBy': orderBy,
                'sortOrder': sortOrder,
            },
            errors: {
                400: `Invalid Parameters supplied`,
                401: `Not Authorized`,
                403: `Forbidden`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Get Admin API Endpoint
     * Get Admin Detail
     * @param xAccessToken 
     * @param userId 
     * @returns any successful operation
     * @throws ApiError
     */
    public static adminDetail(
xAccessToken: string,
userId: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: Admin;
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/profile/admin/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Invalid ID supplied`,
                401: `Not Authorized`,
                404: `Not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Update Admin API Endpoint
     * Update Admin
     * @param xAccessToken 
     * @param userId UserID of admin to return
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateAdmin(
xAccessToken: string,
userId: string,
requestBody: {
firstName?: string;
lastName?: string;
firstNameKana?: string;
lastNameKana?: string;
areaId?: number;
comment?: string;
status?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Admin;
}> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/profile/admin/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Delete Admin API Endpoint
     * Delete Admin
     * @param xAccessToken 
     * @param userId UserID of admin to delete
     * @returns any successful operation
     * @throws ApiError
     */
    public static deleteAdmin(
xAccessToken: string,
userId: string,
): CancelablePromise<{
status?: number;
message?: string;
}> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/profile/admin/{userID}',
            path: {
                'userID': userId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Invalid ID supplied`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server error`,
            },
        });
    }

}
